import { useFormikContext } from "formik";
import { cloneDeep } from "lodash";
import { useState } from "react";
import { Col, Row } from "react-bootstrap";

import {
	FilingReturnFiledOptions,
	FilingReturnInfoNoticeOptions,
	RegimeTypeOptions,
	RegimeTypes
} from "../../../../config/filingConstants";
import { IFormITR1 } from "../../../../config/interfaces";
import { InitDeductUndChapVIA } from "../../../../pages/itr-filing/efiling.config";
import { UtilService } from "../../../../services";
import { FormField, RadioSwitch, SelectInputField } from "../../../fields";
import { ConfirmationModal } from "../../../modals";

const FilingReturnInfoForm = () => {
	const { values, errors, touched, setFieldValue, handleBlur, setFieldTouched } =
		useFormikContext<IFormITR1>();

	const [showChangeRegimeModal, setShowChangeRegimeModal] = useState<any>(null);

	return (
		<>
			<section>
				<div className="section-title-wrap">
					<h5>Type of Regime</h5>
				</div>
				<FormField label="Type of Regime" isRequired={true} sm={4}>
					<>
						<SelectInputField
							placeholder="Select Regime Type"
							name="FilingReturnInfo.RegimeType"
							menuZIndex={9}
							options={UtilService.convertToArray(RegimeTypeOptions)}
							value={{
								"label": RegimeTypeOptions[values.FilingReturnInfo.RegimeType],
								"value": values.FilingReturnInfo.RegimeType
							}}
							onChange={(selectedOption) => {
								if (selectedOption.value === values.FilingReturnInfo.RegimeType) {
									return;
								} else if (selectedOption.value) {
									setShowChangeRegimeModal(() => selectedOption.value);
								} else {
									setFieldValue("FilingReturnInfo.RegimeType", "");
								}
							}}
							onBlur={handleBlur("FilingReturnInfo.RegimeType")}
							isInvalid={
								Boolean(errors.FilingReturnInfo?.RegimeType) && touched.FilingReturnInfo?.RegimeType
							}
							errorMsg={errors.FilingReturnInfo?.RegimeType}
						/>
					</>
				</FormField>
			</section>

			<section>
				<div className="section-title-wrap">
					<h5>Due date for filing return on income</h5>
				</div>

				<FormField label="Filed u/s" isRequired={true} sm={4}>
					<Row className="align-items-center">
						<Col xs={4} sm={3} md={2}>
							<RadioSwitch
								id="FiledToggle"
								name="FiledToggle"
								checked={values.FilingReturnInfo.FiledToggle || false}
								onChange={(checked: boolean) => {
									setFieldValue("FilingReturnInfo.FiledToggle", checked);
									setFieldValue("FilingReturnInfo.FiledNoticeToggle", !checked);
									setFieldValue("FilingReturnInfo.FiledNotice", "");
									setFieldValue("FilingReturnInfo.Filed", "");
									setFieldTouched("FilingReturnInfo.FiledNotice", false);
									setFieldTouched("FilingReturnInfo.Filed", false);
								}}
							/>
						</Col>
						<Col xs={8} sm={9} md={10}>
							<SelectInputField
								placeholder="Select Option"
								name="FilingReturnInfo.Filed"
								menuZIndex={9}
								isOptionArrayOfObject={false}
								options={FilingReturnFiledOptions}
								value={[values.FilingReturnInfo.Filed]}
								onChange={(selectedOption) => {
									if (selectedOption) {
										setFieldValue("FilingReturnInfo.Filed", selectedOption.value);
									} else {
										setFieldValue("FilingReturnInfo.Filed", "");
									}
								}}
								onBlur={handleBlur("FilingReturnInfo.Filed")}
								isDisabled={values?.FilingReturnInfo?.FiledNoticeToggle}
								isInvalid={
									Boolean(errors.FilingReturnInfo?.Filed) && touched.FilingReturnInfo?.Filed
								}
								errorMsg={errors.FilingReturnInfo?.Filed}
							/>
						</Col>
					</Row>
				</FormField>

				<FormField label="Filed in response to notice u/s" isRequired={true} sm={4}>
					<Row className="align-items-center">
						<Col xs={4} sm={3} md={2}>
							<RadioSwitch
								id="FiledNoticeToggle"
								name="FiledNoticeToggle"
								checked={values.FilingReturnInfo.FiledNoticeToggle || false}
								onChange={(checked: boolean) => {
									setFieldValue("FilingReturnInfo.FiledNoticeToggle", checked);
									setFieldValue("FilingReturnInfo.FiledToggle", !checked);
									setFieldValue("FilingReturnInfo.Filed", "");
									setFieldValue("FilingReturnInfo.FiledNotice", "");
									setFieldTouched("FilingReturnInfo.Filed", false);
									setFieldTouched("FilingReturnInfo.FiledNotice", false);
								}}
							/>
						</Col>
						<Col xs={8} sm={9} md={10}>
							<SelectInputField
								placeholder="Select Option"
								name="FilingReturnInfoFiledInResponse"
								menuZIndex={9}
								isOptionArrayOfObject={false}
								options={FilingReturnInfoNoticeOptions}
								value={[values.FilingReturnInfo.FiledNotice]}
								onChange={(selectedOption) => {
									if (selectedOption) {
										setFieldValue("FilingReturnInfo.FiledNotice", selectedOption.value);
									} else {
										setFieldValue("FilingReturnInfo.FiledNotice", "");
									}
								}}
								onBlur={handleBlur("FilingReturnInfo.FiledNotice")}
								isDisabled={values?.FilingReturnInfo?.FiledToggle}
								isInvalid={
									Boolean(errors.FilingReturnInfo?.FiledNotice) &&
									touched.FilingReturnInfo?.FiledNotice
								}
								errorMsg={errors.FilingReturnInfo?.FiledNotice}
							/>
						</Col>
					</Row>
				</FormField>
			</section>

			<ConfirmationModal
				showModal={!!showChangeRegimeModal}
				iconColorClass="text-danger"
				title="Are you sure?"
				message={
					<p>Do you want to change the Type of Regime, as it will change the flow of form.</p>
				}
				onYesBtnClick={() => {
					if (showChangeRegimeModal) {
						setFieldValue("FilingReturnInfo.RegimeType", showChangeRegimeModal);

						let _InitDeductUndChapVIA = { ...InitDeductUndChapVIA };
						if (showChangeRegimeModal === RegimeTypes.OLD_TAX_REGIME) {
							_InitDeductUndChapVIA = cloneDeep(values.TempDeductUndChapVIA);
							setFieldValue("DeductUndChapVIA", _InitDeductUndChapVIA);
						} else {
							setFieldValue("TempDeductUndChapVIA", cloneDeep(values.DeductUndChapVIA));
							_InitDeductUndChapVIA = {
								..._InitDeductUndChapVIA,
								Section80CCDEmployer: values.DeductUndChapVIA.Section80CCDEmployer
							};
							setFieldValue("DeductUndChapVIA", _InitDeductUndChapVIA);
						}

						const _TotalChapVIADeductions = Object.values(_InitDeductUndChapVIA).reduce(
							(curr, value) => curr + value,
							0
						);
						setFieldValue("TotalChapVIADeductions", _TotalChapVIADeductions);
						setShowChangeRegimeModal(() => false);
					}
				}}
				onNoBtnClick={() => setShowChangeRegimeModal(() => null)}
				onYesBtnText="Change"
			/>
		</>
	);
};

export default FilingReturnInfoForm;
